import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-country-code-picker',
  template: `
    <ion-content>
      <ion-list-header>
        <ion-label translate>ACTIONS.selectDialingCode</ion-label>
      </ion-list-header>
      <ion-item *ngFor="let code of codes" (click)="select(code)">
        <ion-label> +{{ code }} </ion-label>
      </ion-item>
    </ion-content>
  `,
})
export class CountryCodePickerComponent implements OnInit {
  @Input() codes: number[] = [];

  constructor(public popoverController: PopoverController) {}

  ngOnInit() {}

  select(code: number) {
    this.popoverController.dismiss(code);
  }
}
